import { SettingsCache } from '~/lib/consts/settings-cache';
import { SmartSendProvider } from '~/lib/consts/providers';
import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';

export function CanArrangeReturn({ Status, BookingDetails }: SmartSendItemApiModel) {
  return (
    Status !== 'Sold' &&
    SettingsCache.settings.Features.includes('ReturnCollection') &&
    BookingDetails?.Service?.Provider === SmartSendProvider
  );
}
